var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from "mobx";
import { APPEvent as AEvent } from "@/events/AppEvents";
import { DateLib } from "@@/Datelib";
import { Apphandler } from "@/ipc/MainAppHandler";
import { RepliesUIRequest } from "@/share/RepliesModel";
export class AllRepliesUIStore {
    constructor() {
        this.messages = new Map();
        this.messagesBySection = new Map();
        this.loading = false;
        this.loadingMore = false;
        this.lastMessageTime = 0; // maybe better to use server side lgic ?
        this.lastCount = -1;
        this.messagecoutrequest = 20;
        this.messageRepliesMap = new Map();
        this.recentLetrid = '';
        makeObservable(this);
        AEvent.addSubscriberForAllReplies((res) => {
            this.setLoading(false);
            this.setLoadingMore(false);
            if (res.length < this.messagecoutrequest) {
                this.setLastCount(0);
            }
            for (const m of res) {
                this.addMessage(m);
            }
        });
    }
    setLastCount(count) {
        this.lastCount = count;
    }
    async loadAllReplies() {
        if (this.loading || this.loadingMore) {
            return;
        }
        this.setLoading(true);
        const req = new RepliesUIRequest();
        req.count = this.messagecoutrequest;
        req.sortAsc = false;
        req.time = new Date().getTime() + 60 * 60 * 24 * 1000;
        Apphandler.sendMessage("allreplies", req);
    }
    setLoading(loading) {
        this.loading = loading;
    }
    setLoadingMore(lm) {
        this.loadingMore = lm;
    }
    addMessage(m) {
        const rmsg = m.latestReplies[m.latestReplies.length - 1];
        if (rmsg != undefined) {
            if (this.lastMessageTime === 0 || rmsg.createdAt < this.lastMessageTime) {
                this.lastMessageTime = rmsg.createdAt;
            }
            this.messageRepliesMap.set(m.pMessage._id, m);
        }
    }
    loadMore() {
        if (this.loadingMore || this.loading) {
            return;
        }
        console.log("loading more...");
        this.setLoadingMore(true);
        const req = new RepliesUIRequest();
        req.count = this.messagecoutrequest;
        req.sortAsc = false;
        req.time = this.lastMessageTime;
        Apphandler.sendMessage("allreplies", req);
    }
    getMessageTime(msg) {
        return DateLib.getTodayTimeOrDate(msg.createdAt);
    }
    reset() {
        this.setLoading(false);
        this.setLoadingMore(false);
        this.lastCount = -1;
        this.lastMessageTime = 0;
        this.recentLetrid = '';
    }
    sortByTime(mrr1, mrr2) {
        const rmsg1time = mrr1.latestReplies.length > 1 ? mrr1.latestReplies[0].createdAt : 0;
        const rmsg2time = mrr2.latestReplies.length > 1 ? mrr2.latestReplies[0].createdAt : 0;
        return rmsg1time - rmsg2time;
    }
    getMessageReplies() {
        return Array.from(this.messageRepliesMap.values()).sort(this.sortByTime).reverse();
    }
}
__decorate([
    observable,
    __metadata("design:type", Map)
], AllRepliesUIStore.prototype, "messages", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AllRepliesUIStore.prototype, "messagesBySection", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AllRepliesUIStore.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AllRepliesUIStore.prototype, "loadingMore", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AllRepliesUIStore.prototype, "lastCount", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AllRepliesUIStore.prototype, "messageRepliesMap", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AllRepliesUIStore.prototype, "setLastCount", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], AllRepliesUIStore.prototype, "loadAllReplies", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AllRepliesUIStore.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AllRepliesUIStore.prototype, "setLoadingMore", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AllRepliesUIStore.prototype, "addMessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AllRepliesUIStore.prototype, "reset", null);
